/// <amd-module name="Agile/SplitView/Components/SplitView" />
import * as React from "react";
import { ISplitterProps, Splitter } from "VSSUI/Splitter";
import { css } from "VSSUI/Util";

/**
 * Renders contents in left and right panel
 * Also serializes the visibility and size settings under given settings path
 */
export class SplitView extends React.Component<ISplitterProps> {
    public render() {
        const { className, nearElementClassName, farElementClassName } = this.props;

        return (
            <Splitter
                // Default min/max widths can be overridden
                minFixedSize={350}
                maxFixedSize={1000}
                {...this.props}
                className={css("split-view", className)}
                nearElementClassName={css("flex-column flex-grow", nearElementClassName)}
                farElementClassName={css("flex-column flex-grow", farElementClassName)}
            />
        );
    }
}
